const initializeDialogs = (openDialogButtons, closeDialogButtons, allDialogs) => {
  allDialogs.forEach( (dialog) => {
    dialog.addEventListener( 'click', function (event) {
      const rect = dialog.getBoundingClientRect();
      const isInDialog = (
        rect.top <= event.clientY
        && event.clientY <= rect.top + rect.height
        && rect.left <= event.clientX
        && event.clientX <= rect.left + rect.width
      );
      if (!isInDialog) {
        dialog.classList.remove( 'open' );
        dialog.close();
      }
    } );

    dialog.addEventListener( 'close', function (event) {
      stopAllYoutube();
    } );
  } );

  openDialogButtons.forEach( (dialogButton) => {
    const dialogToShow = dialogButton.dataset.openDialog;

    if (!dialogToShow) {
      return;
    }

    const dialog = document.querySelector( '[data-dialog=' + dialogToShow + ']' );

    dialogButton.addEventListener( 'click', event => {
      dialog.showModal();
      dialog.classList.add( 'open' );
    } );
  } );

  closeDialogButtons.forEach( (dialogButton) => {
    const dialogToClose = dialogButton.dataset.closeDialog;

    if (!dialogToClose) {
      return;
    }

    const dialog = document.querySelector( '[data-dialog=' + dialogToClose + ']' );

    dialogButton.addEventListener( 'click', event => {
      dialog.classList.remove( 'open' );
      dialog.close();
    } );
  } );
};

const stopAllYoutube = () => {
  const iframes = document.querySelectorAll( 'iframe[src*="youtube.com"]' );
  iframes.forEach( (iframe) => {
    iframe.src = iframe.src;
  } );
};

const dialogs = (openDialogButtons, closeDialogButtons, allDialogs) => {
  if (!openDialogButtons || !closeDialogButtons) {
    return;
  }

  initializeDialogs( openDialogButtons, closeDialogButtons, allDialogs );
};

export default dialogs;
